import { Box, CircularProgress } from "@mui/material";

interface PageLoadingFallbackProps {
  minHeight?: number | string;
}

export function PageLoadingFallback({
  minHeight = 320,
}: PageLoadingFallbackProps) {
  return (
    <Box
      sx={{
        minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress sx={{ color: "var(--oxy-primary)" }} />
    </Box>
  );
}
